export const ORGSI_FREE_DATA = 'ORGSI_FREE_DATA' // Инициализация модуля
export const ORGSI_GR_REQUEST = 'ORGSI_GR_REQUEST' // Запрос данных из госреестра
export const ORGSI_LIST_REQUEST = 'ORGSI_LIST_REQUEST' // Запрос списка СИ организации
export const ORGSI_SI_SET = 'ORGSI_SI_SET' // Устанавливает СИ в качестве текущего
export const ORGSI_SI_ADD = 'ORGSI_SI_ADD' // Добавление СИ в список СИ организации
export const ORGSI_SI_UPDATE = 'ORGSI_SI_UPDATE' // Редактирование СИ в списке СИ организации
export const ORGSI_SI_DELETE = 'ORGSI_SI_DELETE' // Удаление СИ из списка СИ организации
export const ORGSI_FILE_ADD = 'ORGSI_FILE_ADD' // Добавление файла к СИ
export const ORGSI_FILE_DELETE = 'ORGSI_FILE_DELETE' // Удаление файла из СИ

export const ORGSI_SET_SILIST_LOADING_STATE = 'ORGSI_SET_SILIST_LOADING_STATE' // Вызов состояния загрузки списка СИ
